import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Container, Box, Fab, Icon } from '@material-ui/core'
import EditableHTML from '@v4/components/common/EditableHTML'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import { SHARED_LINKS } from '../../Content.const'
import { useContent7 } from './Content7.hooks'

const Content7 = props => {
	const [
		{ classes, className, title, titleConfig, shareText, shareLinks, titleEditable, titleKey },
		{ handleTitleClick, handleTitleChange },
	] = useContent7(props)

	return (
		<Box className={clsx(classes.root, className, 'content7')}>
			<Container className="content7-content">
				<EditableContainer
					visible={!!title}
					fieldConfig={titleConfig}
					onAdd={handleTitleChange}
					editable={titleEditable}
				>
					<div>
						<EditableHTML
							key={titleKey}
							align="center"
							className={clsx(classes.title, 'content7-text-block')}
							gutterBottom
							html={title}
							editable={titleEditable}
							onClick={handleTitleClick}
							onChange={handleTitleChange}
						/>
					</div>
				</EditableContainer>
				<Box className={clsx(classes.iconsContainer, 'content7-items')}>
					{SHARED_LINKS.map(({ key, href, icon }) => {
						if (!shareLinks[key]) return null

						const isValidElement = React.isValidElement(icon)
						const classNameIcon = clsx(classes.icon, icon, 'content7-item-icon')

						const extra = key === 'show_twitter_link' && shareText ? `&text=${shareText}` : ''
						return (
							<Fab
								key={key}
								component="a"
								href={`${href}${extra}`}
								target="_blank"
								rel="noopener noreferrer"
								className={clsx(classes.button, 'content7-item')}
								size="medium"
								color="inherit"
								aria-label="facebook"
							>
								{icon && !isValidElement && <Icon className={classNameIcon} />}
								{isValidElement &&
									React.cloneElement(icon, {
										className: classNameIcon,
									})}
							</Fab>
						)
					})}
				</Box>
			</Container>
		</Box>
	)
}

Content7.propTypes = {
	className: PropTypes.string,
	metaData: PropTypes.shape({
		share_text: PropTypes.instanceOf(PageMetaData),
		title: PropTypes.instanceOf(PageMetaData),
		show_facebook_link: PropTypes.instanceOf(PageMetaData),
		show_twitter_link: PropTypes.instanceOf(PageMetaData),
		show_linkedin_link: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Content7)
